export default {
  title: 'Rezumat vânzări',
  description: 'Vânzările din perioada selectată — utilizați pentru reconciliere facturare cu acest restaurant.',
  filters: {
    period: 'Perioadă',
  },
  presets: {
    this_month: 'Luna aceasta',
    last_month: 'Luna trecută',
    last_30_days: 'Ultimele 30 de zile',
    this_year: 'Anul acesta',
  },
  fields: {
    orders_count: 'Comenzi',
    net_sales: 'Vânzări nete',
    sales_tax: 'Taxă vânzări',
    gross_sales: 'Vânzări brute',
    delivery_fee_tax: 'Taxă livrare (TVA)',
    delivery_fee_gross: 'Taxă livrare (brut)',
    tips_gross: 'Bacșișuri (brut)',
    total: 'Total',
  },
  kpi: {
    before_tax: 'înainte de taxă',
    tips: 'colectate pentru restaurant',
    owed_to_restaurant: 'datorate restaurantului',
  },
  table: {
    title: 'Detaliere',
    subtitle: '{{range}} · Toate sumele în {{currency}}',
    field: 'Câmp',
    amount: 'Sumă',
    empty: 'Nicio comandă în perioada selectată',
    footnote:
      'Vânzările nete exclud taxa; Vânzările brute o includ · Totalul este net de comisioanele platformei, deci nu este suma plătită de client · Rambursările și contestațiile sunt deduse · Sume în {{currency}}',
  },
  buttons: {
    export_csv: 'Exportați CSV',
    refresh: 'Actualizați',
    retry: 'Încercați din nou',
  },
  errors: {
    failed_to_load: {
      title: 'Nu s-a putut încărca rezumatul vânzărilor',
      description: 'A apărut o eroare la încărcarea raportului. Vă rugăm să încercați din nou.',
    },
  },
};
